import React from 'react';

interface HighlightMatchProps {
  text: string;
  query: string;
  highlightColor?: string;
}

export function highlightMatch({ text, query, highlightColor }: HighlightMatchProps): React.ReactNode {
  if (!query.trim()) return text;

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const splitRegex = new RegExp(`(${escapedQuery})`, 'i');

  const parts = text.split(splitRegex);

  return parts.map((part, index) => {
    const isMatch = part.toLowerCase() === query.toLowerCase();

    const key = `${isMatch ? 'match' : 'text'}-${index}`;

    return isMatch ? (
      <mark key={key} style={{ backgroundColor: highlightColor ?? 'rgba(255, 109, 52, 0.3)' }}>
        {part}
      </mark>
    ) : (
      <React.Fragment key={key}>{part}</React.Fragment>
    );
  });
}
